export function getUserDisplayName(user) {
  const parts = user?.name?.split(" ").filter(Boolean) || [];
  if (parts.length === 0) return user?.email || "User";

  const capitalize = (value) =>
    value ? value.charAt(0).toUpperCase() + value.slice(1) : "";

  if (parts.length > 2) {
    return `${capitalize(parts[0])} ${capitalize(parts[2])}`;
  }

  return parts.map(capitalize).join(" ");
}
